const ttlDecorator = require('./decorators/ttlDecorator');
const validationDecorator = require('./decorators/validationDecorator');
const { StorageFactory, STORAGE_BACKEND } = require('./factory');
const { copyStorageItem } = require('./utils/copyStorageItem');

module.exports = {
  StorageDecorators: {
    ttlDecorator,
    validationDecorator,
  },
  StorageFactory,
  STORAGE_BACKEND,
  StorageUtils: {
    copyStorageItem,
  },
};
